<template>
  <div class="w-100">
    <Jumbotron :item="niche" :type="type" :name="nicheName" />
    <b-container fluid>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="position-absolute w-100">
            <Loading />
          </div>
          <GridCSS v-else :items="nicheContent" :send-vector-click="true" :list="itemList">
            <template #default="slotProps">
              <NormalVectorOverlay :data="slotProps.data" />
            </template>
          </GridCSS>
          <GrouperPaginator
            :name-page="type"
            :total-pages="nicheTotalPages"
            :current-page="nicheCurrentPage"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GridCSS from '@/components/Common/GridCSS';
import { ITEM_LISTS } from '@/utils/analytics/ecommerce';
import GrouperPaginator from '@/components/Groupers/GrouperPaginator';
import Jumbotron from '@/components/Common/Jumbotron';
import Loading from 'UI/Loading';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';

export default {
  components: {
    GridCSS,
    GrouperPaginator,
    Jumbotron,
    Loading,
    NormalVectorOverlay
  },
  computed: {
    // La lista que mide la grilla (VEX-6460). `ITEM_LISTS` es un import y el
    // template solo ve propiedades de la instancia.
    itemList() {
      return ITEM_LISTS.niche;
    },
    ...mapState('niches', [
      'niche',
      'nicheContent',
      'nicheCurrentPage',
      'nicheTotalPages',
      'isLoading'
    ]),
    ...mapGetters('experience', ['isDesignActive']),
    nicheName() {
      return this.isDesignActive
        ? this.$t('main.groupers.topics.title')
        : this.$t('main.groupers.nitches.title');
    },
    type() {
      return this.isDesignActive ? 'topics' : 'niches';
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 27px;
}
p {
  font-size: 16px;
}
.badge-secondary {
  background: #b8aea4;
}
</style>
